import { ICountry } from '@module/shared';

export async function FetchCountries(): Promise<ICountry[]> {    
    const url = `${environmentSettings.webapiUrl}/v1/Request/Countries`;
    const response = await fetch(encodeURI(url));
    if (response.ok) {
      const requestLog: ICountry[] = await response.json();
      return requestLog;
    } else {      
      return Promise.reject({status: response.status, statusText: response.statusText});
    }
  }
  // tslint:disable-next-line:eofline
  